export const GET_GLOBALS_REQUESTED = 'GET_GLOBALS_REQUESTED'
export const GET_GLOBALS_SUCCEEDED = 'GET_GLOBALS_SUCCEEDED'
export const GET_GLOBALS_FAILED = 'GET_GLOBALS_FAILED'
